import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import BatteryFullIcon from '@mui/icons-material/BatteryFull';
import Battery80Icon from '@mui/icons-material/Battery80';
import Battery60Icon from '@mui/icons-material/Battery60';
import Battery50Icon from '@mui/icons-material/Battery50';
import Battery30Icon from '@mui/icons-material/Battery30';
import Battery20Icon from '@mui/icons-material/Battery20';
import Battery1BarIcon from '@mui/icons-material/Battery1Bar';
import SignalCellular0BarIcon from '@mui/icons-material/SignalCellular0Bar';
import SignalCellular1BarIcon from '@mui/icons-material/SignalCellular1Bar';
import SignalCellular2BarIcon from '@mui/icons-material/SignalCellular2Bar';
import SignalCellular3BarIcon from '@mui/icons-material/SignalCellular3Bar';
import SignalCellular4BarIcon from '@mui/icons-material/SignalCellular4Bar';
import NetworkWifi1BarIcon from '@mui/icons-material/NetworkWifi1Bar';
import NetworkWifi2BarIcon from '@mui/icons-material/NetworkWifi2Bar';
import NetworkWifi3BarIcon from '@mui/icons-material/NetworkWifi3Bar';
import NetworkWifiIcon from '@mui/icons-material/NetworkWifi';

const numericValue = value => {
    if(value === null || value === undefined || value === '') return null;
    const number = Number(value);
    return Number.isFinite(number) ? number : null;
};

export const getBatteryDisplay = batteryLevel => {
    const level = numericValue(batteryLevel);
    if(level === null) return null;

    if(level <= 10) return {IconComponent: Battery1BarIcon, iconColor: '#d32f2f'};
    if(level <= 20) return {IconComponent: Battery20Icon, iconColor: '#f44336'};
    if(level <= 39) return {IconComponent: Battery30Icon, iconColor: '#f9a825'};
    if(level <= 59) return {IconComponent: Battery50Icon, iconColor: '#fb8c00'};
    if(level <= 69) return {IconComponent: Battery60Icon, iconColor: '#7cb342'};
    if(level <= 79) return {IconComponent: Battery80Icon, iconColor: '#43a047'};
    if(level <= 89) return {IconComponent: Battery80Icon, iconColor: '#2e7d32'};
    return {IconComponent: BatteryFullIcon, iconColor: '#1b5e20'};
};

export const getRssiDisplay = rssiLevel => {
    const level = numericValue(rssiLevel);
    if(level === null) return null;

    if(level <= -90) return {IconComponent: SignalCellular0BarIcon, iconColor: '#d32f2f'};
    if(level <= -80) return {IconComponent: SignalCellular1BarIcon, iconColor: '#f44336'};
    if(level <= -70) return {IconComponent: SignalCellular2BarIcon, iconColor: '#fb8c00'};
    if(level <= -60) return {IconComponent: SignalCellular3BarIcon, iconColor: '#7cb342'};
    return {IconComponent: SignalCellular4BarIcon, iconColor: '#1b5e20'};
};

export const getSnrDisplay = snrLevel => {
    const level = numericValue(snrLevel);
    if(level === null) return null;

    if(level <= 7.5) return {IconComponent: NetworkWifi1BarIcon, iconColor: '#d32f2f'};
    if(level <= 15) return {IconComponent: NetworkWifi2BarIcon, iconColor: '#fb8c00'};
    if(level <= 22.5) return {IconComponent: NetworkWifi3BarIcon, iconColor: '#7cb342'};
    return {IconComponent: NetworkWifiIcon, iconColor: '#1b5e20'};
};

const TelemetryIcon = ({display, title, rotate=false}) => {
    if(!display) return null;
    const {IconComponent, iconColor} = display;

    return (
        <Tooltip title={title} arrow>
            <IconComponent style={{
                color: iconColor,
                fontSize: '1em',
                ...(rotate && {transform: 'rotate(90deg)'})
            }}/>
        </Tooltip>
    );
};

const SensorTelemetryIcons = ({battery, rssi, snr}) => {
    const batteryValue = numericValue(battery);
    const rssiValue = numericValue(rssi);
    const snrValue = numericValue(snr);

    if(batteryValue === null && rssiValue === null && snrValue === null) return null;

    return (
        <span style={{display:'inline-flex', alignItems:'center', gap:'0.3rem', marginLeft:'0.45rem', verticalAlign:'middle'}}>
            <TelemetryIcon display={getBatteryDisplay(batteryValue)} title={`Battery: ${batteryValue}%`} rotate/>
            <TelemetryIcon display={getRssiDisplay(rssiValue)} title={`RSSI: ${rssiValue} dBm`}/>
            <TelemetryIcon display={getSnrDisplay(snrValue)} title={`SNR: ${snrValue} dB`}/>
        </span>
    );
};

export default SensorTelemetryIcons;
